<template>
  <div class="card mb-3">
    <h4 class="card-header">
      Search
    </h4>
    <div class="card-body">
      <form @submit.prevent="doSearch">
        <div class="input-group">
          <input
            v-model="query"
            type="text"
            class="form-control"
            name="s"
            pattern=".{3,}"
            required
            title="3 characters minimum"
            placeholder="Search"
            aria-label="Search"
          >
          <div class="input-group-append">
            <button
              class="btn btn-primary"
              type="submit"
            >
              <i class="fa fa-search" />
            </button>
          </div>
        </div>
      </form>
      <button
        v-show="searched"
        button
        class="btn btn-danger mt-2"
        @click="clearSearch"
      >
        <i class="fa fa-times" /> Clear Search
      </button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      query: null
    }
  },
  computed: {
    searched() {
      return !!this.query;
    }
  },
  watch: {
    '$route.query.s': function (s) {
      this.setSearch();
    },
  },
  mounted () {
    this.setSearch();
  },
  methods: {
    doSearch() {
      this.$router.push({
        query: { s: this.query }
      });
    },
    clearSearch() {
      let query = Object.assign({}, this.$route.query);
      delete query.s;
      this.$router.replace({ query });
    },
    setSearch() {
      this.query = this.$route.query.s;
    }
  }
}
</script>